
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'product-list',
		prop1: '',
		prop2: '',
		prop3: [],

		productList: [],
		productComp: '0',

		itemList: [],
		itemComp: '0',

	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2; state.prop3 = payload.prop3 },

		setProducts(state, payload) { state.productList = payload.info; state.productComp = payload.info1; },
		setProductsComp(state, payload) { state.productComp = payload.info1; },

		setProductItems(state, payload) { state.itemList = payload.info; state.itemComp = payload.info1; },
		setProductItemsComp(state, payload) { state.itemComp = payload.info1; },
		
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getAllProducts(context, payload) {
			context.commit("setProductsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallproducts')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProducts", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllProductItems(context, payload) {
			context.commit("setProductItemsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallitems')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProductItems", { info: b, info1: '1' }) 
	          	});
	    }
		
		
		
		
	}

})